const translations = {
    copyCheckbox: 'Send me a copy',
    to: 'To'
};

export default translations;
